export { AddAddress } from './AddAddress';
export { AddProviders } from './AddProviders';
export { AddressCard } from './AddressCard';
export { NewProject } from './NewProject';
export { Share } from './Share';
export { Why } from './Why';
export { EditAddresses } from './EditAddresses';



// WEBPACK FOOTER //
// ./src/view/screens/ModalBodies/index.js